import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";

export default class Radio extends React.PureComponent {
	constructor(props) {
		super(props);
		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(event) {
		this.props.onChange(event.target.value);
	}

	render() {
		const blockClasses = clsx("Radio", this.props.className);
		return (
			<label className={blockClasses} title={this.props.titleTooltip} disabled={this.props.radioDisabled}>
				<input
					type="radio"
					name={this.props.name}
					value={this.props.value}
					disabled={this.props.radioDisabled}
					className={"Radio_control"}
					checked={this.props.checked}
					onChange={this.handleChange}
				/>
				{this.props.label}
			</label>
		);
	}
}

Radio.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	label: PropTypes.string,
	titleTooltip: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	className: PropTypes.string,
	radioDisabled: PropTypes.bool,
	checked: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
};
